import { Exception } from '@vodafoneis/sjonvarpskjarni-js-lib';

export default class THEOPlayerInitializationException extends Exception {
	constructor(message?: string) {
		super(message, 'THEOPlayerInitializationException');
		Object.setPrototypeOf(this, THEOPlayerInitializationException.prototype);
	}
}
